import {Flex} from 'antd';
import React from 'react';

const PCFFormHeader: React.FC<{title: string; description: string}> = ({
  title,
  description
}) => {
  return (
    <Flex vertical={true} gap={10} style={{margin: '0 0 20px 0'}}>
      <div
        style={{
          color: '#024064',
          fontFamily: 'Montserrat',
          fontSize: '18px',
          fontStyle: 'normal',
          fontWeight: '700',
          lineHeight: '120%'
        }}
      >
        {title}
      </div>
      <div
        style={{
          color: '#101223',
          fontFamily: 'Montserrat',
          fontSize: '13px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '120%'
        }}
      >
        {description}
      </div>
    </Flex>
  );
};

export default PCFFormHeader;
